import React from "react";
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaCopy,
} from "react-icons/fa";

const Contact = React.forwardRef((props, ref) => {
  const email = "woolleysamuel06@gmail.com";
  const phone = "+233203790592";
  const whatsapp = "+233555313216";
  const location = "Accra, Ghana";

  // Copy to clipboard helper
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert(`Copied: ${text}`);
  };

  const cardStyle = {
    background: "#fff",
    padding: "1.5rem",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    textDecoration: "none",
    color: "#333",
    minWidth: 0, // ✅ allow flex children to shrink
  };

  const textContainerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    minWidth: 0, // ✅ prevent overflow
    flex: 1,
  };

  const infoTextStyle = {
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "250px", // ✅ keeps it inside the card
  };

  return (
    <section
      ref={ref}
      style={{
        minHeight: "20vh",
        padding: "2rem 1rem",
        background: "linear-gradient(to right, #ffffff, #f5f5f5)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h2
        className="text-3xl md:text-4xl font-extrabold mb-8"
        style={{
          color: "#8B4513",
          textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
        }}
      >
        📞 Get in Touch
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "1.5rem",
          maxWidth: "1100px",
          width: "100%",
        }}
      >
        {/* Email */}
        <a href={`mailto:${email}`} style={cardStyle}>
          <div style={textContainerStyle}>
            <FaEnvelope size={24} color="#3a3ad3ff" />
            <div style={{ minWidth: 0 }}>
              <p style={{ fontWeight: "bold", margin: 0 }}>Email</p>
              <p style={infoTextStyle}>{email}</p>
            </div>
          </div>
          <FaCopy
            style={{ cursor: "pointer", color: "#888", flexShrink: 0 }}
            onClick={(e) => {
              e.preventDefault();
              copyToClipboard(email);
            }}
          />
        </a>

        {/* Phone */}
        <a href={`tel:${phone}`} style={cardStyle}>
          <div style={textContainerStyle}>
            <FaPhone size={24} color="#20ec49ff" />
            <div style={{ minWidth: 0 }}>
              <p style={{ fontWeight: "bold", margin: 0 }}>Phone</p>
              <p style={infoTextStyle}>{phone}</p>
            </div>
          </div>
          <FaCopy
            style={{ cursor: "pointer", color: "#888", flexShrink: 0 }}
            onClick={(e) => {
              e.preventDefault();
              copyToClipboard(phone);
            }}
          />
        </a>

        {/* WhatsApp */}
        <a
          href={`https://wa.me/${whatsapp.replace(/\D/g, "")}`}
          target="_blank"
          rel="noreferrer"
          style={cardStyle}
        >
          <div style={textContainerStyle}>
            <FaWhatsapp size={24} color="#25D366" />
            <div style={{ minWidth: 0 }}>
              <p style={{ fontWeight: "bold", margin: 0 }}>WhatsApp</p>
              <p style={infoTextStyle}>{whatsapp}</p>
            </div>
          </div>
          <FaCopy
            style={{ cursor: "pointer", color: "#888", flexShrink: 0 }}
            onClick={(e) => {
              e.preventDefault();
              copyToClipboard(whatsapp);
            }}
          />
        </a>

        {/* Location */}
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            location
          )}`}
          target="_blank"
          rel="noreferrer"
          style={cardStyle}
        >
          <div style={textContainerStyle}>
            <FaMapMarkerAlt size={24} color="#d9534f" />
            <div style={{ minWidth: 0 }}>
              <p style={{ fontWeight: "bold", margin: 0 }}>Location</p>
              <p style={infoTextStyle}>{location}</p>
            </div>
          </div>
          <span
            style={{
              background: "#8B4513",
              color: "#fff",
              padding: "0.4rem 0.8rem",
              borderRadius: "6px",
              fontSize: "0.8rem",
              flexShrink: 0,
            }}
          >
            Map
          </span>
        </a>
      </div>
    </section>
  );
});

export default Contact;
